/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTransferIn = createReactComponent("transfer-in", "IconTransferIn", [
  ["path", { d: "M4 18v3h16v-14l-8 -4l-8 4v3", key: "svg-0" }],
  ["path", { d: "M4 14h9", key: "svg-1" }],
  ["path", { d: "M10 11l3 3l-3 3", key: "svg-2" }]
]);

export { IconTransferIn as default };
//# sourceMappingURL=IconTransferIn.js.map
